import { render, staticRenderFns } from "./MoveAlertTables.vue?vue&type=template&id=4bce3e98&"
import script from "./MoveAlertTables.vue?vue&type=script&lang=js&"
export * from "./MoveAlertTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports